var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_51156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45248 13.1762L6.4525 13.1763L6.45623 13.1725L8.66131 10.969L8.92055 11.2283L6.71723 13.4316L6.71716 13.4316C6.02348 14.1257 5.08251 14.5157 4.10125 14.516C3.12 14.5162 2.17883 14.1266 1.4848 13.433C0.790775 12.7393 0.400735 11.7983 0.400488 10.8171C0.400242 9.83581 0.789808 8.89464 1.48349 8.20062L1.48355 8.20055L3.68639 5.99565L3.94589 6.25496L1.74246 8.45993L1.74244 8.45991L1.73868 8.46377C1.12783 9.09175 0.788787 9.93498 0.794904 10.811C0.801021 11.6871 1.15181 12.5255 1.77137 13.1449C2.39093 13.7642 3.22944 14.1148 4.10549 14.1207C4.98153 14.1265 5.82467 13.7873 6.45248 13.1762Z",
    fill: "#797D8A",
    stroke: "#797D8A",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90208 1.68099C9.46396 1.67986 9.02997 1.76566 8.62524 1.9334C8.22071 2.10107 7.85344 2.34727 7.54467 2.65777C7.54451 2.65793 7.54435 2.65809 7.5442 2.65824L5.34017 4.86072L5.08085 4.60122L7.28693 2.39721L7.28773 2.39641C7.63023 2.05228 8.03754 1.77947 8.48612 1.59373C8.9347 1.408 9.41565 1.31303 9.90116 1.31432L9.90321 1.31432C10.3889 1.31312 10.8701 1.40833 11.3188 1.59442C11.7674 1.78052 12.1747 2.0538 12.517 2.39844L12.5175 2.39899C13.2101 3.09366 13.599 4.03465 13.5988 5.01561C13.5986 5.99656 13.2094 6.9374 12.5165 7.63179L10.3135 9.8337L10.0537 9.5739L12.2571 7.37058L12.2571 7.37055C12.7231 6.90447 13.0404 6.31068 13.169 5.66427C13.2976 5.01785 13.2317 4.34781 12.9795 3.73887C12.7274 3.12993 12.3003 2.60941 11.7524 2.24312C11.2047 1.87699 10.5609 1.68138 9.90208 1.68099ZM9.90208 1.68099L9.90105 2.08099L9.90119 1.68099C9.90149 1.68099 9.90178 1.68099 9.90208 1.68099Z",
    fill: "#797D8A",
    stroke: "#797D8A",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65981 5.43029L4.51562 9.57446L5.34058 10.3994L9.48477 6.25524L8.65981 5.43029Z",
    fill: "#797D8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_51156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.914062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.3a859ddd96f4e910dffc83ad2fbe17fa.svg";
export { ForwardRef as ReactComponent };